import React, { useState } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FaArrowLeft } from "react-icons/fa";
import TermsModal from "../components/TermsModal";
import "./Login.css";

const Login = () => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(true);
  const navigate = useNavigate();
  const { route } = useParams();

  const handleLogin = async () => {
    if (!identifier || !password) {
      setErrors({
        api: "Please provide all required information.",
      });
      return;
    }
    if (!agreedToTerms) {
      setErrors({
        ...errors,
        terms: "You must agree to the Terms and Conditions."
      });
      return;
    }
    setLoading(true);
    try {      const isEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(identifier);
      const response = await fetch(
        `${API_BASE_URL}/login-site`,
        {
          method: "POST",
          body: JSON.stringify({
            email: isEmail ? identifier : null,
            phone: !isEmail ? identifier : null,
            password,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        if (data.statusCode === 1) {
          sessionStorage.setItem("user", JSON.stringify(data));
          navigate(`/${route}`);
        } else {
          const apiErrors = data.statusMessage.reduce((acc, error) => {
            if (typeof error === "string") {
              return { ...acc, api: error };
            }
            return { ...acc, api: "An unknown error occurred." };
          }, {});
          setErrors(apiErrors);
        }
      } else {
        const apiErrors = data.statusMessage?.reduce?.((acc, error) => {
          if (typeof error === "string") {
            return { ...acc, api: error };
          }
          return { ...acc, api: "An unknown error occurred." };
        }, {}) || { api: "An unknown error occurred." };
        setErrors(apiErrors);
      }
    } catch (error) {
      setErrors({ api: "An unexpected error occurred." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div
        className="card p-4 login-card"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <div className="d-flex align-items-center justify-content-between mb-4">
          <button
            className="btn btn-link text-decoration-none d-flex align-items-center"
            onClick={() => navigate("/")}
          >
            <FaArrowLeft className="me-2" />
            Home
          </button>
          <h2 style={{ width: "55%" }} className="text-left mb-1">
            Login
          </h2>
        </div>

        <div className="mb-3">
          <label className="form-label">Email / Phone Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="Email / Phone Number"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
          />
        </div>

        <div className="mb-2 position-relative">
          <label className="form-label">Password</label>
          <input
            type={showPassword ? "text" : "password"}
            className="form-control"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            style={{
              position: "absolute",
              right: "15px",
              top: "60%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#6c757d",
              zIndex: 2,
            }}
            onClick={() => setShowPassword((v) => !v)}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </span>
        </div>

        <div className="text-end mb-3">
          <span
            className="text-primary text-decoration-underline"
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </span>
        </div>

        {errors.api && <div className="text-danger mb-2">{errors.api}</div>}

        <div className="mb-2">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="termsCheckbox"
              checked={agreedToTerms}
              onChange={e => setAgreedToTerms(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="termsCheckbox">
              I Agree to the <span style={{color: '#007bff', cursor: 'pointer'}} onClick={() => setShowTerms(true)}>Terms and Conditions</span>
            </label>
          </div>
          {errors.terms && <div className="text-danger">{errors.terms}</div>}
        </div>
        <TermsModal show={showTerms} onClose={() => setShowTerms(false)} />
        <button
          className="btn btn-primary w-100"
          onClick={handleLogin}
          disabled={loading || !agreedToTerms}
        >
          {loading ? "Verifying..." : "Login"}
        </button>

        <div className="text-center mt-3">
          Don't have an account?{" "}
          <span
            className="text-primary text-decoration-underline"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/signup")}
          >
            Sign Up
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
